// extracted by mini-css-extract-plugin
export default {"container":"Div_container__KzVcC","darkmode":"Div_darkmode__bJqvk"};